import React from 'react'
import { Image } from 'Components/view-image'
const emptyImg = require('static/empty-envelope.png')
const Empty = () => {
  return (
    <>
      <div className="tw-flex tw-h-full tw-h-full tw-items-center tw-mt-120 tw-justify-center tw-flex-col md:tw-mb-0 tw-mb-120">
        <Image src={emptyImg} height={120} width={120} />
        <p className="tw-mt-6 tw-text-12 md:tw-text-14 tw-text-color-gray-800">
          暂无内容
        </p>
      </div>
    </>
  )
}
export default Empty
